import { Button } from "@vds/buttons";
import { Modal, ModalFooter, ModalTitle } from "@vds/modals";
import { Text } from '@vds/core';
import { MarginSpacerL, MarginSpacerM, MarginSpacerXS } from "common/components/styleTag";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { InputStepper } from "@vds/input-stepper";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { addToCart, setPlansFirstAllDevices, setPlansFirstDevices } from "pages/Mobility/ducks/MobilitySlice";
import { setLinesCount, setLinesRemain, setLinesUpdated } from "pages/PlanFirst/ducks/PlanFirstSlice";

const PlansFirstLinesModal = (props) => {
  const globalData = useSelector((state) => state.GlobalData);
  const pageData = useSelector(state => state.MobilityPage)
  const PlanFirstData = useSelector((state) => state.PlanFirst);
  const packages = globalData?.sessionCartData?.apiResponse?.prospectFlowData?.cart?.packages;
  const { t } = useTranslation(["plans-first-new"]);
  const dispatch = useDispatch()
  const [lines, setLines] = useState(Number.parseInt(PlanFirstData?.linesCount));
  const [selectedPlansPricing , setSelectedPlansPricing] = useState(PlanFirstData?.selectedPlansFirstData);
  const [isFlexPlan, setIsFlexPlan] = useState(PlanFirstData?.selectedFlexPlan);
  const numberOfLines=t("plans-first-new.linesModal.numberOfLines", { ns: "plans-first-new" })
  const maxLinesRemain = PlanFirstData?.linesCount + (9 - Object.keys(packages).length)
  const discountedPrice = PlanFirstData?.plans?.configuration?.discount?.autoPayDiscount || 5;
  const updateLines = () => {
    const currentLines = PlanFirstData.linesCount
    const currentLinesRemain = PlanFirstData?.linesRemain
    const difLines = Number.parseInt(lines) - Number.parseInt(currentLines)
    let linesRemaining = Number.parseInt(currentLinesRemain) + Number.parseInt(difLines)
    if(difLines != 0) {
      callToUpdateLines(difLines)
      dispatch(setLinesRemain(linesRemaining > 0 ? linesRemaining : 0))
      dispatch(setLinesCount(Number.parseInt(lines)))
      dispatch(setLinesUpdated(true))
    }
    props.close()
  }

  const callToUpdateLines = (difLines) => {
    let payloadLinesArray = []
    let deletePackages = {}

    const linePackages = []
    Object.entries(pageData?.plansFirstAllDevices || {})
                        .forEach(([key, pkg], index) => {
                          if(pkg?.packageId?.toUpperCase().includes("LINE")) {
                            linePackages[index] = pkg
                          }
                        });
    const linePkgs = linePackages.reverse()

    if(Object.keys(linePkgs).length < difLines < 0 ? difLines*-1 : difLines) {
      let revIndex = Object.keys(pageData?.plansFirstDevices).length
      let linePkgIdsLength = Object.keys(linePkgs).length

      Array(Object.keys(pageData?.plansFirstDevices).length).fill(null).map((item, index) => {
        linePkgs[linePkgIdsLength++] = pageData?.plansFirstDevices[--revIndex]
      })
    }

    if(difLines < 0) {
      Array(difLines*-1)
      .fill(null)
      .map((item, index) => {
        let pkg = linePkgs[index];
        deletePackages[index] = pkg
      })
    let deletePackageIds = []
    Object.entries(deletePackages).map(([key, item], index) => {
      const line = {
        "packageId": item.packageId,
        "packageType": item.packageType,
        "operation": "DELETE",
      }
      payloadLinesArray[index] = {...line}
      deletePackageIds[index] = item.packageId
    })

  const updatedPackages = []
    Object.entries(pageData?.plansFirstDevices || {})
                        .forEach(([key, pkg], index) => {
                          if(!deletePackageIds?.includes(pkg?.packageId)) {
                            updatedPackages[index] = pkg
                          }
                        });

    const updatedAllPackages = []
    Object.entries(pageData?.plansFirstAllDevices || {})
                        .forEach(([key, pkg], index) => {
                          if(!deletePackageIds?.includes(pkg?.packageId)) {
                            updatedAllPackages[index] = pkg
                          }
                        });
  dispatch(setPlansFirstDevices(updatedPackages))
  dispatch(setPlansFirstAllDevices(updatedAllPackages))

  } else {
    const line = {
      "packageId": "",
      "packageType": "REGULAR",
    "operation": "ADD",
      "quantity": difLines,
      "plan": {
        "planId": PlanFirstData?.plansFirstData?.planId
      }
    }
    payloadLinesArray[0] = {...line}
  }

    const payload = {
      "cartMeta": {
        "zipCode": PlanFirstData?.plansFirstData?.zipCode,
        "shoppingPath": "prospect",
        "flow": "plans-first",
      },
      "lines": payloadLinesArray
    }
    dispatch(addToCart(payload))
  }

  return (
    <>
      <PlanFirstLinesModal
        hideCloseButton={true}
        disableOutsideClick={true}
        onOpenedChange={(e) => {
          if (!e) {
            props.close(null);
          }
        }}
        opened={!!props.showModal}
        data-track="close"
        disableFocusLock={true}
      >
        <ModalTitle>
          <Text kind="title" size="medium">
            <ModalTitleHeading>
              {t("plans-first-new.linesModal.heading", { ns: "plans-first-new" })}
            </ModalTitleHeading>
          </Text>
          <MarginSpacerM></MarginSpacerM>
        </ModalTitle>

        <Text kind="body" size="small">
          {t("plans-first-new.linesModal.description", { ns: "plans-first-new" })}
        </Text>
        <MarginSpacerL></MarginSpacerL>
        <LinesContainer>
          <Text kind="body" size="large" bold>
            {t("plans-first-new.linesModal.linesText", { ns: "plans-first-new" })}
          </Text>
          <span style={{ marginTop: "4px" }}><Text kind="micro">
            {t("plans-first-new.linesModal.maxLinesText", { ns: "plans-first-new" })}
          </Text>
          </span>
        </LinesContainer>
          <InputStepperContainer>
            <span style={{paddingRight:"1rem"}}>
        <InputStepperWrapper>
          <InputStepper
            defaultValue={PlanFirstData?.linesCount || 1}
            disabled={false}
            error={false}
            maxValue={maxLinesRemain}
            minValue={1}
            readOnly={false}
            surface="light"
            width="121px"
            height="44px"
            onChange={(val) => { setLines(val) }}
          />
        </InputStepperWrapper>
            </span>
        <TitleSpan>
          { !isFlexPlan ? <Text kind="title" size="medium" bold>{"$" + (parseInt(selectedPlansPricing?.priceInfo[parseInt(lines>numberOfLines ? numberOfLines :lines) - 1]?.finalPrice)?.toFixed(0) - Number(discountedPrice))}</Text>
            : <Text kind="title" size="medium" bold>{"$" + parseInt(selectedPlansPricing?.monthlyFee)}</Text>}
          </TitleSpan>
          <PricingSpan><Text kind="micro">{t("plans-first-new.linesModal.perLine", { ns: "plans-first-new" })}</Text></PricingSpan>
        
        </InputStepperContainer>
        <MarginSpacerXS />
        <ModalFooter style={{ padding: "1rem 0 0.25rem 0.125rem" }}>
          <ButtonContainer>
            <StyledButton
              size="medium"
              onClick={() => {
                updateLines();
              }}
            >
              {t("plans-first-new.linesModal.updateButton", { ns: "plans-first-new" })}
            </StyledButton>
            <StyledButton
              use="secondary"
              size="medium"
              onClick={() => { props.close() }}
            >
              {t("plans-first-new.linesModal.cancelButton", { ns: "plans-first-new" })}
            </StyledButton>
          </ButtonContainer>
          <ChargesText>
            {t("plans-first-new.linesModal.chargesText", { ns: "plans-first-new" })}
          </ChargesText>
        </ModalFooter>

      </PlanFirstLinesModal>
    </>
  );
}

const PlanFirstLinesModal = styled(Modal)`
  height: 484px;
  width:560px;
  @media screen and (max-width: 767px) {
    width: 360px;
    height: 250px;
  }
  @media screen and (max-width: 480px) {
    padding: 16px 0px 0px 16px;
  }
  @media screen and (max-width: 378px) {
    padding: 16px 0px 0px 16px;
  }
`;

const ModalTitleHeading = styled.div`
  font-weight: 700;
  font-size: 32px;
  line-height: 36px;
  flex: none;
  order: 1;
  align-self: stretch;
  flex-grow: 0;
  @media only screen and (max-width: 767px) {
    font-size: 24px;
  }
`;

const LinesContainer = styled.div`
  display: flex;
  aling-items: flex-left;
  flex-direction: row;
  gap: 12px;
`
const LinesHeading = styled.div`
  font-weight: 700;
  font-size: 16px;
  line-height: 20px;
  flex: none;
  order: 1;
  align-self: stretch;
  flex-grow: 0;
  @media only screen and (max-width: 767px) {
    font-size: 20px;
  }
`;

const MaxLines = styled.div`
  font-weight: 400;
  font-size: 11px;
  line-height: 22px;
  flex: none;
  order: 1;
  align-self: stretch;
  flex-grow: 0;
  @media only screen and (max-width: 767px) {
    font-size: 11px;
  }
`;

const PricingSpan = styled.span`
white-space:nowrap;
padding-top:0.5rem;
margin-left:-5px;
`;

const TitleSpan = styled.span`
padding-top:0.5rem;
`

const InputStepperWrapper = styled.div`
  display: flex;
  [class^=InputStepperWrapper-VDS]{
    border: 1px solid #6F7171;
  }
 
  @media only screen and (max-width: 767px) {
    justify-content: center;
    flex-direction: column;
    width: 100%;
    [class^=InputStepperWrapper-VDS]{
      width: 100%;
    }
  }
`

const ChargesText = styled.div`
  font-weight: 400;
  font-size: 11px;
  line-height: 16px;
`;

const ButtonContainer = styled.div`
margin-top:-1rem;
  width: 100%;
  display: flex;
  gap: 1rem;
  justify-content: flex-start;
  margin-bottom:25px;
  align-items:center;
  @media only screen and (max-width: 768px) {
    flex-direction: column;
  }
`;
const StyledButton = styled(Button)`
  display: flex;
  font-size: 16px;
  width:226px;
  span {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
  @media only screen and (min-width:320px) and (max-width: 768px) {
    width:100%
  }
`;

const InputStepperContainer = styled.div`
display: flex;
 gap: 0.5rem;
 padding-top:8px;
`

export default PlansFirstLinesModal;
